/**
 * description:
 * Calendar page — embeds the FASA Google Calendar so members can
 * see all events for the year.
 */
import { Box, useMediaQuery } from "@mui/material";
import PageHero from "../../../utils/PageHero";
import calendarHero from "../../../pictures/Hero/CalendarHero.svg";

const CALENDAR_BASE_PARAMS =
  "height=600&wkst=1&ctz=America%2FNew_York&showPrint=0&showTz=0&title=FASA%2026-27&src=ZTBiMjQyMjgyZmVhY2ZjYzNhYWQ2MWI2N2I2ZjZiZmFjYjYzNjU0MjhiZGJjY2U1NGUzYzIzY2Y4MmZkMTA4MUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&src=ZDdmaW5kd2Vic2l0ZUBnbWFpbC5jb20&color=%23b39ddb&color=%23009688";

// Google's month grid doesn't reflow for narrow screens — it just shrinks
// until the text is unreadable. Agenda (list) mode is built for that instead.
const CALENDAR_EMBED_SRC = `https://calendar.google.com/calendar/embed?${CALENDAR_BASE_PARAMS}`;
const CALENDAR_EMBED_SRC_MOBILE = `https://calendar.google.com/calendar/embed?mode=AGENDA&${CALENDAR_BASE_PARAMS}`;

function CalendarPage() {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <>
      <PageHero
        image={calendarHero}
        viewBoxWidth={1909}
        viewBoxHeight={372}
        cropHeight={372}
        bandColor="#AD5D4E"
        accessibleTitle="FASA Calendar"
        pt={{ xs: "78px", sm: "76px", md: "90px", lg: "100px" }}
        width={{ xs: "94vw", sm: "620px", md: "760px", lg: "1200px", xl: "1406px" }}
      />

      <Box sx={{ bgcolor: "primary.main", px: { xs: "20px", md: "48px" }, py: { xs: "48px", md: "80px" } }}>
        <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
          {isSmallScreen ? (
            <Box
              sx={{
                width: "100%",
                height: "75vh",
                bgcolor: "background.default",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <Box
                component="iframe"
                src={CALENDAR_EMBED_SRC_MOBILE}
                title="FASA Events Calendar"
                frameBorder="0"
                scrolling="yes"
                sx={{ width: "100%", height: "100%", border: 0 }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                position: "relative",
                width: "100%",
                pb: "75%",
                bgcolor: "background.default",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <Box
                component="iframe"
                src={CALENDAR_EMBED_SRC}
                title="FASA Events Calendar"
                frameBorder="0"
                scrolling="no"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
              />
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
}

export default CalendarPage;
